/* eslint-disable react/display-name */
/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import Box from "@material-ui/core/Box";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import useStyles from "../../CockpitStyleJs/styleFilter";
import Tooltip from "@material-ui/core/Tooltip";
import { useDispatch, useSelector } from "react-redux";
import i18n from "i18n";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import React, { useEffect, useState } from "react";
import { Chip, Grid } from "@mui/material";
import DoneIcon from "@material-ui/icons/Done";
import { TagsList } from "components/Tags/TagsList";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PeopleIcon from "@material-ui/icons/People";
import _lod from "lodash";
import { InputAdornment } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";

/**
 *
 * @returns
 */
export default ({ role, handleConUserFilter }) => {
	const { users } = useSelector(state => state.userGroup);
	const [userOpenDialog, setUserOpenDialog] = React.useState(false);
	const dispatch = useDispatch();
	const [selected, setSelected] = useState([]);
	const [search, setSearch] = React.useState("");
	const { cockpit } = useSelector(state => state.assistantconfig);

	const classes = useStyles();
	let userSet = selected.length !== 0;

	let showUserFilterAgent = cockpit?.displayAgentFilterForAgent === true && role === "agent";
	const isAllUsersChecked = selected.length === users.length;

	/**
	 *
	 */
	const handleCloseUserFilterDialog = () => {
		dispatch(setUserOpenDialog(false));
	};

	/**
	 *
	 */
	const handleSaveFilters = clear => {
		if (!_lod.isNil(selected)) {
			let selectedUserEmail = selected.map(user => user._id);
			handleConUserFilter(clear ? [] : selectedUserEmail);
		}
		handleCloseUserFilterDialog();
	};

	/**
	 *
	 */
	const handleDisableFilters = () => {
		setSelected([]);
		handleSaveFilters(true);
	};

	/**
	 *
	 * @param {*} value
	 */
	const toggleSelectAll = value => {
		if (isAllUsersChecked) {
			setSelected([]);
		} else {
			setSelected(users);
		}
	};

	/**
	 *
	 * @param {*} event
	 */
	const handleSearchChange = event => {
		setSearch(event.target.value);
	};

	useEffect(() => {
		if (userOpenDialog === false) {
			setSearch("");
		}
	}, [userOpenDialog]);

	return role === "supervisor" || role === "soloUser" || showUserFilterAgent ? (
		<>
			<Tooltip title={i18n.t("COC.UserFilter")} placement="top">
				<Box className={classes.filterButton} mt={1}>
					<ToggleButtonGroup exclusive size="small">
						<ToggleButton
							value={true}
							fontSize="small"
							onClick={() => {
								dispatch(setUserOpenDialog(true));
							}}
							style={userSet ? { color: "black", background: "#0000001f" } : {}}
						>
							<PeopleIcon fontSize="small" />
						</ToggleButton>
					</ToggleButtonGroup>
				</Box>
			</Tooltip>
			<Dialog
				fullWidth
				maxWidth="md"
				open={userOpenDialog}
				onClose={() => handleCloseUserFilterDialog()}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					{i18n.t("COC.UserFilter")}{" "}
					<span style={{ float: "right" }}>
						{/* Select all toggle */}
						<Chip
							label={isAllUsersChecked ? i18n.t("COC.deselectAll") : i18n.t("COC.selectAll")}
							color={isAllUsersChecked ? "default" : "primary"}
							deleteIcon={isAllUsersChecked ? <HighlightOffIcon /> : <DoneIcon />}
							clickable={true}
							onClick={() => {
								toggleSelectAll();
							}}
							onDelete={() => {
								toggleSelectAll();
							}}
						/>
					</span>
				</DialogTitle>
				<DialogContent dividers>
					<Box m={1}>
						<TextField
							fullWidth
							label=""
							variant="outlined"
							size="small"
							onChange={handleSearchChange}
							InputProps={{
								startAdornment: (
									<InputAdornment position="start">
										<SearchIcon />
									</InputAdornment>
								)
							}}
						/>
					</Box>
					<Grid container>
						<TagsList
							list={users
								.filter(user => {
									if (search.trim().length >= 0) {
										let fullSearch =
											(user.name || "") + " " + (user.surname || "") + " " + user._id;
										return fullSearch.toLowerCase().includes(search.toLowerCase());
									} else {
										return true;
									}
								})
								.sort((a, b) => a.name.localeCompare(b.name))}
							labelField={"name"}
							surnameField={"surname"}
							titleField={"_id"}
							valueField={"_id"}
							isForm={true}
							selected={selected}
							setSelected={setSelected}
							isUser
						/>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleDisableFilters()} color="primary">
						{`${i18n.t("COC.DisableFilter")}`}
					</Button>
					<Button onClick={() => handleCloseUserFilterDialog()} color="secondary">
						{`${i18n.t("COC.Cancel")}`}
					</Button>
					<Button
						disabled={selected.length === 0}
						onClick={() => handleSaveFilters()}
						color="primary"
					>
						{`${i18n.t("COC.ApplyFilters")}`}
					</Button>
				</DialogActions>
			</Dialog>
		</>
	) : (
		<></>
	);
};
